/*
 * WA的发送模板
 *
 * *
 * */
import { collectionServiceClient } from "@/api/collectionServiceClient";
import { GetWhatsAppMsgMapReq} from "@/pbjs/xcommon/collection_pb";
import InnerRequest from "./request";
export interface Options {
    CaseLevel?: string;
    OrderId?: string;
    lang?: string;
}
export function setGetWhatsAppMsgMapReq(arg: Options) {
    let request: any = new GetWhatsAppMsgMapReq();
    request.setCaselevel(arg.CaseLevel);
    request.setOrderid(arg.OrderId);
    request.setLang(arg.lang);
    return request;
}
export const getWhatsAppMsgMapRequest = new InnerRequest(
    collectionServiceClient,
    // collectionServiceClient.ReduceCreditCardFee
    collectionServiceClient.getWhatsAppMsgMap
);
